import React from 'react';
import './Teeth_Whitening.css';
import Teeth_Whiting_img from '../images/pexels-cottonbro-5999363.jpg';
export default function TEETH_WHITENING(){

    return(
        
        <div className="container_Teeth_W">
 <h1>TEETH WHITENING</h1>
            <div className="img_box_Teeth_W">
            <img src={Teeth_Whiting_img} className="img_of_Teeth_W" alt=""/>
        </div>
        <div className="text_main_Teeth_W">
              <p>Teeth brightening methods are utilized to light up the presence of a patient's grin – at times 
 5 to 10 shades better in just one session. As per the Dental Association, teeth brightening strategies have turned into probably the most common dental medications among patients all through the nation. Proficient brightening uses more grounded brightening operators that convey quicker and more successful outcomes.
              </p>
                  <h1>DID YOU KNOW??</h1>
                  <p>  That the teeth normally deepen in shade as we age. Drinks and pharmaceuticals can add to a darker, yellowed grin. It is achievable to eradicate long periods of stains in a solitary expert brightening session and maintain those outcomes for a long time with appropriate upkeep. As indicated by the Academy of Cosmetic Dentistry, proficient brightening is best kept up by a blend of good oral consideration and bring home brightening medicines as prescribed by your dental specialist.
                  </p>                
                <div className="FAQ_Service_Teeth_W">
              <h2>FAQ'S</h2>
          </div>
          </div>       
    </div>
    
        
    )
}